import {
    Tag,
    Listbox,
    Combobox,
    Icon,
    AutoSelection, Label, InlineStack,
} from '@shopify/polaris';
import {SearchMajor} from '@shopify/polaris-icons';
import {useState, useCallback, useEffect} from 'react';

function MultipleSelect(
    {
        label = 'Search',
        initialOptions,
        onUpdate = (value) => {},
        selectedOptions = [],
    }
) {
    const [inputValue, setInputValue] = useState('');
    const [options, setOptions] = useState(initialOptions);
    useEffect(() => {
        setOptions(initialOptions)
    }, [initialOptions])

    const escapeSpecialRegExCharacters = useCallback(
        (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'),
        [],
    );

    const updateText = useCallback(
        (value) => {
            setInputValue(value);

            if (value === '') {
                setOptions(initialOptions);
                return;
            }
            const filterRegex = new RegExp(escapeSpecialRegExCharacters(value), 'i');
            const resultOptions = initialOptions.filter((option) =>
                option.label.match(filterRegex),
            );
            setOptions(resultOptions.slice(0, 10));
        },
        [initialOptions, escapeSpecialRegExCharacters],
    );

    const updateSelection = useCallback(

        (selected) => {
            if (selectedOptions.includes(selected)) {
                onUpdate(
                    selectedOptions.filter((option) => option !== selected),
                );
            } else {
                onUpdate([...selectedOptions, selected]);
            }

            updateText('');
        },
        [selectedOptions, updateText],
    );

    const removeSelection = useCallback(
        (tag) => () => {
            const options = [...selectedOptions];
            options.splice(options.indexOf(tag), 1);
            onUpdate(options);
        },
        [selectedOptions],
    );

    const selectedOptionsMarkup = options.filter(option => selectedOptions.includes(option.value)).sort((a,b) => selectedOptions.indexOf(a.value) - selectedOptions.indexOf(b.value)).map((option, key) => (
        <Tag key={`option-${option.value}`} onRemove={removeSelection(option.value)}>
            {option.label}
        </Tag>
    ));

    const optionsMarkup =
        options.length > 0
            ? options.map((option) => {
                const {label, value} = option;

                return (
                    <Listbox.Option
                        key={`${value}`}
                        value={value}
                        selected={selectedOptions.includes(value)}
                        accessibilityLabel={label}
                    >
                        {label}
                    </Listbox.Option>
                );
            })
            : null;

    return (
        <>
            <div style={{marginBottom: '0.25rem'}}>
                <div style={{marginBottom: '0.25rem'}}>
                    <Label>
                        {label}
                    </Label>
                </div>
                <Combobox
                    allowMultiple
                    activator={
                        <Combobox.TextField
                            prefix={<Icon source={SearchMajor} />}
                            onChange={updateText}
                            value={inputValue}
                            autoComplete="off"
                        />
                    }
                >
                    {optionsMarkup ? (
                        <Listbox
                            autoSelection={AutoSelection.None}
                            onSelect={updateSelection}
                        >
                            {optionsMarkup}
                        </Listbox>
                    ) : null}
                </Combobox>
            </div>

            {selectedOptionsMarkup.length > 0 && <InlineStack>{selectedOptionsMarkup}</InlineStack>}
        </>
    );
}

export default MultipleSelect
